// extracted by mini-css-extract-plugin
export var active = "Header-module--active--1d8cd";
export var barger = "Header-module--barger--728a1";
export var bookDemo = "Header-module--bookDemo--ebe5f";
export var container = "Header-module--container--94d97";
export var employee = "Header-module--employee--b60d4";
export var links = "Header-module--links--83e17";
export var linksContent = "Header-module--linksContent--5b5d9";
export var mainLogo = "Header-module--mainLogo--88fcf";
export var mobileMenu = "Header-module--mobileMenu--8297b";
export var scrollHeader = "Header-module--scrollHeader--22199";
export var title = "Header-module--title--3665f";